<template>
    <PageContent>
        <PageTitle>Customers <Help /></PageTitle>
        <NotReady v-if="!ready" />
        <div v-else>
          <!-- {{ customers.length }} -->
          <DataTable :data="customers"  :options="{
              pageLength: 2,
              lengthMenu: [[2, 25, 50, 100, -1], [2, 25, 50, 100, `All`]]
            }" :columns="[
            { data: 'No_' },
            { data: 'Name' },
            { data: 'City' },
            { data: 'Phone No_' },
            { data: null, orderable: false, searchable: false }
          ]" class="display table table-striped table-bordered is-responsive" style="width:100%">

            <template #column-4="{ row, rowIndex }">
              <a href="#" @click.prevent="impersonate(row)" class="me-1 mt-1 mb-1 btn btn-sm btn-primary" data-title="View As" data-intro="Impersonate a customer.">View As</a>
              <a :href="`/customers/${row['No_']}/users/`" class="me-1 mt-1 mb-1  btn btn-sm btn-primary" data-title="Customer Users" data-intro="View all users for this customer.">Users</a>
              <a :href="`/customers/${row['No_']}/edit`" class="me-1  mt-1 mb-1 btn btn-sm btn-secondary" data-title="Edit Customer" data-intro="Edit the customer">Edit</a>
            </template>
          </DataTable>
        </div>
        
    </PageContent>
  </template>
  
  <script>
  // @ is an alias to /src
    import ColumnChooser from '@/components/Items/ColumnChooser.vue';
    import PriceCodes from '@/components/Items/PriceCodes.vue';
    import ItemListCodeArea from '@/components/Items/ItemListCodeArea.vue';
    import Modal from '@/components/Modal.vue';
    import PageContent from '@/components/PageContent.vue';
    import NotReady from '@/components/NotReady.vue';
    import PageTitle from '@/components/PageTitle.vue';
    import ScrollingTable from '@/components/Table/ScrollingTable.vue';
    import Help from '@/components/Help.vue';
    import VueSimpleAlert from 'vue3-simple-alert';
    import axios from 'axios'
    import DataTable from 'datatables.net-vue3'
    import DataTablesCore from 'datatables.net-bs5'
    
  // Register DataTables with Bootstrap 5 styling
    DataTable.use(DataTablesCore)

  export default {
    name: 'CustomersView',
    components: {Modal, PageContent, PageTitle, NotReady, PriceCodes, ItemListCodeArea, ColumnChooser, ScrollingTable, Help, DataTable},

    data(){
      return {
        _:_,
        allCustomers:[],
        rows:[],
        filter:{
            orderBy:'Name',
            order:'asc'
        },
        ready:false,
        searchText:'',
        search:{
            searchString:['true'],
            'No_':'',
            'City':'',
            'Name':'',
            'Phone No_':''
        },
        pagination:{
            search:'',
            pages:0,
            per_page:20,
            page:0,
        },
      }
    },
    async mounted(){
      let res = await axios.get(`${this.$store.state.api}/customers?`);
      this.allCustomers = res;
      this.ready = true;
    },
    computed:{
      customers:function(){
        return _.filter(_.orderBy(this.allCustomers,this.filter.orderBy, this.filter.order), c=>{
          let searchText = this.searchText.replace(/\./gi, '').toLowerCase();
          let name = c['Name'].replace(/\./gi, '').toLowerCase().trim();
          let city = c['City'].replace(/\./gi, '').toLowerCase().trim();
          let no = (c['No_']).toString().trim();
          return no.startsWith(searchText)||name.startsWith(searchText)||city.startsWith(searchText);
        });
      }
    },
    methods:{
      async impersonate(customer){
        let req, res;
        sessionStorage.clear();
        localStorage.removeItem('shipTos');
        localStorage.removeItem('shipTo');
        localStorage.removeItem('openInvoices');
        localStorage.removeItem('account_status');
        
        sessionStorage.customer = JSON.stringify(customer);
        this.$store.state.sessionStorage.customer = customer;

        window.location = '/dashboard/';
      }
    },
    
  }
  </script>
  <style lang="scss" scoped>
  .is-responsive{
    @media (max-width:  992px){
      [data-title="Customers"]{
        .table-body-parent{
          table.table{
            // border: 5px solid red !important
            display:block;
            > tbody{
              display:block;
              tr{
                display:block;
                margin-bottom: 1rem;
                td{
                  display:block;
                  width: 100%;
                  &:nth-of-type(1){
                    &:before{
                      content:  'Customer No: ';
                      font-weight:bold;
                    }
                  }
                  &:nth-of-type(2){
                    &:before{
                      content:  'Customer Name: ';
                      font-weight:bold;
                    }
                  }
                  &:nth-of-type(3){
                    &:before{
                      content:  'City: ';
                      font-weight:bold;
                    }
                  }
                  &:nth-of-type(4){
                    &:before{
                      content:  'Phone: ';
                      font-weight:bold;
                    }
                  }
                  &:last-child{
                    .btn{
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
    
  </style>